<template>
    <div class="main">
        <div class="aa-top">
            <img class="logo" src="../assets/edsights-logo.png" alt="EdSights logo" />
            <br />
            <br />
            <AlertCard
                v-if="loaded && !error"
                class="alert-card"
                :alert="alert"
                :statusUpdating="statusUpdating"
                @to-student-page="toStudentProfile"
                @on-status-update="updateStatus"
                :expandMessageContext="true"
            />
            <div class="loading-container" v-if="!loaded && !error">
                <BaseLoading />
            </div>
            <h2 v-if="error">{{ displayMessage }}</h2>
            <br />
            <br />
            <Button class="btn" type="button" @click="goToAlerts">{{ buttonMessage }}</Button>
        </div>
    </div>
</template>

<script>
import Button from '@/components-deprecated/Button';
import AlertCard from '@/components-deprecated/admin/AlertCard';
import { getAlertContextAndUpdateTimedValue, updateAlert } from '@/api/alerts';
import { objectToCamelCase } from '../services/utils';
import { BaseLoading } from '@edsights/ui-core';
import { useRootStore } from '@/stores';
export default {
    name: 'AlertAction',
    components: {
        Button,
        AlertCard,
        BaseLoading
    },
    setup() {
        const rootStore = useRootStore();

        return {
            rootStore
        };
    },
    data() {
        return {
            displayMessage: 'Whoops, something went wrong. Please try again.',
            error: false,
            alert: {},
            loaded: false,
            code: '',
            st: '',
            statusUpdating: false
        };
    },
    async created() {

        try {
            const { code, st } = this.$route.query;
            this.code = code;
            this.st = st;
            const isUserLoggedIn = this.user?.id ? true : false;

            const result = await getAlertContextAndUpdateTimedValue({
                code,
                st,
                pageload: true,
                isUserLoggedIn
            });

            if (result?.status === 'error') {
                this.displayMessage = result.message;
                throw new Error();
            }

            this.alert = objectToCamelCase(result.data);
            this.loaded = true;
        } catch (error) {
            this.error = true;
        }
    },
    methods: {
        goToAlerts() {
            this.$router.push({ name: 'Alerts' });
        },
        toStudentProfile(id) {
            this.$router.push({ name: 'StudentDetail', params: { id: id } });
        },
        async updateStatus(alertId, status, message) {
            try {
                const userId = this.user?.id ? this.user.id : null;

                const payload = {
                    code: this.code,
                    st: this.st,
                    status,
                    userId
                };

                this.statusUpdating = true;
                await updateAlert(payload);

                const result = await getAlertContextAndUpdateTimedValue({
                    code: this.code,
                    st: this.st,
                    pageload: false,
                    isUserLoggedIn: userId ? true : false
                });

                if (result?.status === 'error') {
                    this.displayMessage = result.message;
                    this.$Alert.alert({
                        type: 'error',
                        message: result.message,
                        timeout: 3000
                    });
                    this.statusUpdating = false;
                    return;
                }

                this.alert = objectToCamelCase(result.data);
                this.statusUpdating = false;

                this.$Alert.alert({
                    type: 'success',
                    message,
                    timeout: 3000
                });
            } catch (error) {
                this.$Alert.alert({
                    type: 'error',
                    message: 'Unable to update alert. Please try again.',
                    timeout: 3000
                });
            }
        }
    },
    computed: {
        user() {
            return this.rootStore.user;
        },
        buttonMessage() {
            return this.user?.id ? 'View Alerts' : 'Log in and view Alerts';
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/animations';

.main {
    display: flex;
    justify-content: start;
    flex-direction: column;
    width: 100%;
    position: relative;
}

.btn {
    padding: 5px;
}

.box-container {
    margin: 2rem 2rem 0 2rem;
}
.aa-top {
    text-align: center;
    margin: 5rem;
    position: relative;
    z-index: 2;
    .logo {
        max-width: 14rem;
        margin-left: -0.5rem;
    }
}
.aa-box {
    text-align: center;
    max-width: 35rem;
    margin: auto;
}
.alert-card {
    padding: 2rem 4rem;
    border: 1px solid $secondary-gray;
    margin: 2rem;
    border-radius: 8px;
    text-align: left;
}
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
